import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllFile } from '../../store/features/file/fileSlice';
import Button from '../../components/Button/Button';
import { FaRegCircle } from 'react-icons/fa';

const Download = () => {
    document.title = 'MACRUM | Download'
    document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/download')
    const dispatch = useDispatch();
    const {files} = useSelector((store) => store.file)

    useEffect(() => {
        dispatch(getAllFile())
    }, [])

    const handleDownload = async (url, title) => {
        const blob = await fetch(url).then((response) => response.blob());
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', title);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    
  return (
    <div className='px-4 lg:px-16 py-4 pt-28 relative' id='pricing'>
      
        <h2 className='h2 text-white pb-4 text-center w-80 md:w-96 mx-auto relative z-10'>Download</h2>

        <div className='w-full col-span-3'>
            <div className='flex flex-wrap justify-center gap-y-8 md:gap-x-4'>
                {files.data?.map((file, index) => {
                    if (file.brand?.name === "MACRUM POS") {
                        return <div key={index} className='px-12 lg:px-14 py-4 border-2 border-blue-800 bg-blue-950 rounded-3xl z-10'>
                            <div className='relative flex flex-col items-center gap-2 mb-8'>

                                <div className='flex flex-col gap-6 my-8'>
                                    <p className='text-white text-3xl font-semibold'>{file.title}</p>
                                </div>

                                <Button icon={FaRegCircle} text='Download' onClick={() => handleDownload(file.url, file.title)} />
                            </div>
                        </div>
                    }
                })}
            </div>
        </div>
    </div>
  )
}

export default Download
